import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import Pagination from '@/components/ui/pagination/Pagination';
import BookReviewItem from '@/components/ui/book-review-item/BookReviewItem';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { IReviews, IReviewsData } from '@/interfaces/reviews.interface';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { getCurrentPageName } from '@/helpers/helpers';

export interface ILibraryProps {
  data: IReviews;
}

const Comments: FC<ILibraryProps> = ({ data }) => {
  const pagesCount = Math.ceil(data?.total_count / BOOKS_FOR_PAGE);

  //Seo block
  const SEO_TITLE = `Отзывы пользователей на книги :: Электронная библиотека : новые отзывы наших читателей на книги${getCurrentPageName(data.page)}`;
  const SEO_DESCRIPTION = 'Отзывы и рекомендации на прочитанные книги  :: Коллекция бесплатных книг в электронном варианте :: BookZ.ru.';
  const SEO_CANONICAL = '/comments';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()} breadcrumbs={<Breadcrumbs firstPageName="Новые отзывы" />}>
      <SectionTitle name="Отзывы и рекомендации к книгам" />
      <div>
        {data.data.map((comment: IReviewsData) => (
          <BookReviewItem review={comment} key={comment.book_id} />
        ))}
      </div>
      <Pagination pagesCount={pagesCount ?? 0} postName="comments/page=" />
    </Layout>
  );
};

export default Comments;
